<template>
  <v-card outlined>
    <v-card-title>{{ containerTitle }}</v-card-title>
    <v-card-subtitle>{{ containerSubtitle }}</v-card-subtitle>
    <v-divider></v-divider>
    <v-card-text class="pa-0 grey lighten-5 text-center">
      <div class="font-weight-bold pt-10">{{ bodyTitle }}</div>
      <div>{{ description }}</div>
      <v-btn text color="primary" class="mt-10 mb-8" @click="$emit('click')">{{
        btnText
      }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    containerTitle: { type: String, default: "" },
    containerSubtitle: { type: String, default: "" },
    bodyTitle: { type: String, default: "" },
    description: { type: String, default: "" },
    btnText: { type: String, default: "" },
  },
};
</script>

<style>
</style>